export default "__VITE_ASSET__BFqKs2VQ__"